module.exports = __webpack_public_path__ + "static/media/logo-licitanet.2ad838c5.svg";